import { StyleSheet } from 'react-native';

import {
  extraSmallMarginBottomBox,
  extraSmallPaddingVerticalBox,
  smallPaddingHorizontalBox,
} from '../view-style';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    ...extraSmallPaddingVerticalBox,
    ...smallPaddingHorizontalBox,
  },
  textContainer: {
    ...smallPaddingHorizontalBox,
    ...extraSmallMarginBottomBox,
  },
  button: {
    flexDirection: 'row',
    marginBottom: 0,
  },
});
